export const groupBy = (key) => (array) =>
  array.reduce((acc, obj) => {
    const value = obj[key];
    acc[value] = (acc[value] || []).concat(obj);
    return acc;
  }, {});
